import { string } from "prop-types";

export const onCloseModal = ({ setStateDialogIndividualTask }) => {
    return setStateDialogIndividualTask(false);
};

export const onConfirmModal = ({
    methods,
    data,
    cbOnSuccessAdd = () => null,
}) => {
    //* verify if the task is document_required and the user doesnt upload a required document.
    if (data?.document_required && data?.saved_files.length === 0) {
        methods.setError("document_action", {
            type: string,
            message:
                "dans ce cas, le document est requis, veuillez ajouter un document.",
        });
        return;
    }
    // callback pour enregistrer en local cette tache
    cbOnSuccessAdd(data);
    return;
};

export const onOpenModal = ({ setStateDialogIndividualTask }) => {
    return setStateDialogIndividualTask(true);
};
